import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';
import { sortingExpOrderedProvidersByCountry, isSortingExperimentCountry } from './data';
import { BuyboxRegularOffer } from '@/components/buybox-new/types';

// ?preferred_variant=BUYBOX_SORTNG_EXP_V2:control
// ?preferred_variant=BUYBOX_SORTNG_EXP_V2:variant_1

// ?remove_preferred_experiment=BUYBOX_SORTNG_EXP_V2

export const BuyBoxSortingExpName = 'BUYBOX_SORTNG_EXP_V2' as const;

export type BuyBoxSortingExpVariants = ToVariants<typeof BuyBoxSortingExpVariants>;

export const BuyBoxSortingExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
} as const;

export default generate(BuyBoxSortingExpName, BuyBoxSortingExpVariants);

export function sortProviders(providers: BuyboxRegularOffer[], country: string) {
	const provider_ids_sorted = isSortingExperimentCountry(country) ? sortingExpOrderedProvidersByCountry[country] : [];

	return providers.toSorted((a, b) => {
		const indexA = provider_ids_sorted.indexOf(a.package.packageId);
		const indexB = provider_ids_sorted.indexOf(b.package.packageId);

		if (indexA === -1 && indexB === -1) return 0; // both not found
		if (indexA === -1) return 1; // a not found, b found
		if (indexB === -1) return -1; // a found, b not found

		return indexA - indexB;
	});
}
